import {
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Button,
  Heading,
  Flex,
} from "@aws-amplify/ui-react";

export default function SwitchProfileMinorsViewTable({
  activeProfile,
  minorDependentsData = [],
  onStopSessionClick,
  onSwitchClick,
}) {
  return (
    <Flex direction={"column"}>
      <Heading>My minor dependents</Heading>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell as="th">Actions</TableCell>
            <TableCell as="th">Given Name</TableCell>
            <TableCell as="th">Nickname</TableCell>
            <TableCell as="th" display={{ base: "none", medium: "block" }}>
              Relationship
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {minorDependentsData?.map((minor) => {
            return (
              <TableRow key={`spmvt_mdd_${minor?.minorUserId}`}>
                <TableCell>
                  {activeProfile?.patientUserId === minor?.minorUserId ? (
                    <Button
                      size="small"
                      variation="destructive"
                      onClick={onStopSessionClick.bind(
                        this,
                        minor?.minorUserId
                      )}
                    >
                      STOP SESSION
                    </Button>
                  ) : (
                    <Button
                      size="small"
                      variation="primary"
                      onClick={onSwitchClick.bind(
                        this,
                        minor?.minorUserId,
                        minor?.givenName,
                        minor?.nickname
                      )}
                    >
                      SWITCH
                    </Button>
                  )}
                </TableCell>
                <TableCell>{minor?.givenName || ""}</TableCell>
                <TableCell>{minor?.nickname || ""}</TableCell>
                <TableCell display={{ base: "none", medium: "block" }}>
                  {minor?.minorRelationship || ""}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Flex>
  );
}
